
export class BuildConfig {
  public static readonly INT_API_VERSION = 102;
}
